import { ISocialMedia } from '@features/cms/typescript';
import styles from '@features/homepage/sections/SocialMedia/SocialMediaSection.styles';
import SocialMedia from '@components/SocialMedia/SocialMedia';
type PropsType = {
  socialMedia: ISocialMedia;
  isFirst?: boolean;
};
const SocialMediaSection = ({
  socialMedia,
  isFirst = false
}: PropsType) => <section sx={styles.section} data-testid="SocialMediaSection">
    <SocialMedia socialMedia={socialMedia} isFirst={isFirst} />
  </section>;
export default SocialMediaSection;